module.exports = __webpack_public_path__ + "img/ic_super_feedback.b685dadc.png";